import React from 'react';

import ProductIcon from 'app/features/landing/productComparison/components/icons/ProductIcon.styled';

const FanProductIcon = () => (
  <ProductIcon xmlns="http://www.w3.org/2000/svg" title="Fan">
    <path
      fill="none"
      d="M9.25 36L2 11.44l14.5 6.4L26 3l9.5 14.84 14.5-6.4L42.76 36z"
    />
    <path fill="none" d="M30.5 24.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" />
  </ProductIcon>
);

export default FanProductIcon;
